function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class';
import Carousel from '@mozaic-ds/freemarker/js/modules/_carousel.js';
import AddToCartForTopProducts from '../commons/addToCartForTopProduct.class';
var TOP_PRODUCTS_SWIPER = 'js-secondary-top-products-swiper';
var TOP_PRODUCTS_CAROUSEL = 'js-zoom-on-carousel';
var SecondaryTopProducts = /*#__PURE__*/function (_lm$Composant) {
  function SecondaryTopProducts(id) {
    var _this;
    _classCallCheck(this, SecondaryTopProducts);
    _this = _callSuper(this, SecondaryTopProducts, [id]);
    var component = document.getElementById(id);
    var elemSliderTopProducts = component.querySelector(".".concat(TOP_PRODUCTS_SWIPER));
    var elemCarouselTopProducts = component.querySelector(".".concat(TOP_PRODUCTS_CAROUSEL));
    if (elemSliderTopProducts) {
      var swiperTopProductObject = {};
      swiperTopProductObject.instance = new SwiperSlider(".".concat(TOP_PRODUCTS_SWIPER));
      delete swiperTopProductObject.instance;
    }
    if (elemCarouselTopProducts) {
      var carouselTopProductsObject = {};
      carouselTopProductsObject.instance = new Carousel(elemCarouselTopProducts);
      delete carouselTopProductsObject.instance;
    }
    var addToCartForTopProductsInstance = new AddToCartForTopProducts(component, _this.cartUpdate);
    addToCartForTopProductsInstance.init();
    return _this;
  }
  _inherits(SecondaryTopProducts, _lm$Composant);
  return _createClass(SecondaryTopProducts);
}(lm.Composant);
lm.DOMReady(function () {
  var sectionElem = document.querySelectorAll('.component-secondary-top-products');
  for (var i = 0; i < sectionElem.length; i++) {
    var idElem = sectionElem[i].getAttribute('id');
    if (idElem) {
      var secondaryTopProductsObject = {};
      secondaryTopProductsObject.instance = new SecondaryTopProducts(idElem);
      delete secondaryTopProductsObject.instance;
    }
  }
});